"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { WP_Term_Query } from "@/integrations/wordpress/wp_term_query";
import { EcommerceTermsProvider, useEcommerceTerms, type EcommerceTerm } from "@/integrations/wordpress/WordPressEcommerceTermsProvider";
const getGridClass = (index: number) => {
  const pattern = index % 6;
  switch (pattern) {
    case 0:
      return "md:col-span-2 md:row-span-2 aspect-[4/3] md:aspect-square";
    case 1:
    case 2:
      return "md:col-span-1 md:row-span-1 aspect-[4/3] md:aspect-[3/4]";
    case 3:
      return "md:col-span-1 md:row-span-1 aspect-[4/3] md:aspect-square";
    default:
      return "md:col-span-1 md:row-span-1 aspect-[4/3]";
  }
};
function CategoryCard({
  term,
  index
}: {
  term: EcommerceTerm;
  index: number;
}) {
  const imageSrc = term.image_url || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570849/img/generic_mountain_gear.png";
  return <Link to={term.link || "#"} className={`group relative block overflow-hidden rounded-xl bg-muted ${getGridClass(index)}`} data-index={index}>
      {}
      <div className="absolute inset-0 h-full w-full">
        <img src={imageSrc} alt={term.name} className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110" loading="lazy" />
      </div>

      {}
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent transition-colors duration-500 group-hover:bg-primary/90 group-hover:from-primary/90 group-hover:via-primary/80" />

      {}
      <div className="absolute inset-0 flex flex-col justify-end p-6 transition-all duration-300 group-hover:justify-center group-hover:items-center group-hover:text-center">
        <div className="translate-y-0 transition-transform duration-500 group-hover:-translate-y-2">
          <h3 className="text-2xl font-bold text-white uppercase tracking-tight md:text-3xl">
            {term.name}
          </h3>
          
          {}
          <div className="mt-2 flex items-center gap-2 text-white/80 group-hover:justify-center group-hover:text-white">
            <span className="text-sm font-medium uppercase tracking-wider">
              Explore Collection
            </span>
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </div>
        </div>
      </div>
    </Link>;
}
function CategoriesGrid() {
  const {
    terms,
    loading,
    error,
    refetch
  } = useEcommerceTerms();
  if (loading) {
    return <div className="grid grid-cols-1 gap-4 md:grid-cols-3 md:auto-rows-[300px]">
        {[...Array(6)].map((_, i) => <div key={i} data-index={i} className={`animate-pulse rounded-xl bg-muted/20 ${getGridClass(i)}`} />)}
      </div>;
  }
  if (error) {
    return <div className="flex min-h-[400px] flex-col items-center justify-center rounded-xl border border-dashed border-muted p-8 text-center">
        <p className="mb-4 text-muted-foreground">
          Unable to load collections at this time.
        </p>
        <Button onClick={refetch} variant="outline">
          Retry Connection
        </Button>
      </div>;
  }
  if (!terms || terms.length === 0) {
    return <div className="flex min-h-[300px] items-center justify-center rounded-xl border border-muted/20 bg-muted/5 p-8 text-center">
        <p className="text-lg font-medium text-muted-foreground">
          No collections found.
        </p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-4 md:grid-cols-3 md:auto-rows-[minmax(250px,auto)]">
      {terms.map((term, i) => <CategoryCard key={term.id} term={term} index={i} />)}
    </div>;
}
export default function ApparelForTheMission() {
  const wp_term_query_params = {
    taxonomy: "product_cat",
    per_page: 6,
    orderby: "count",
    order: "desc"
  };
  const wp_term_query = new WP_Term_Query(wp_term_query_params);
  return;
}